import { Mail, MapPin } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Chapter } from "@/components/Chapter";
import { AnswerBlock } from "@/components/AnswerBlock";
import { BUSINESS } from "@/data/site";

export const Contact = () => (
  <section id="contatti" data-testid="section-contatti" className="bg-paper py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-5 md:px-8">
      <Reveal>
        <Chapter number="06" kicker="Contatti" title="Come richiedere un preventivo gratuito?" />
      </Reveal>
      <Reveal delay={0.1}>
        <AnswerBlock>
          Per un preventivo gratuito basta inviare una email a amministrazione@medcompetente.it
          indicando il numero di lavoratori e le mansioni: BPMedLav risponde entro 24-48 ore
          lavorative con una proposta su misura. Lo studio riceve a Roma, in Viale di Villa
          Pamphili 99, su appuntamento.
        </AnswerBlock>
      </Reveal>

      <div className="mt-14 grid gap-px bg-ink/10 border border-ink/10 md:grid-cols-2">
        <Reveal className="bg-paper">
          <a
            href={`mailto:${BUSINESS.email}?subject=Richiesta%20preventivo%20sorveglianza%20sanitaria`}
            data-testid="contact-email-link"
            className="group flex h-full flex-col p-8 md:p-10 transition-colors hover:bg-clinic-tint/60"
          >
            <Mail size={22} className="text-clinic mb-5" />
            <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-ink/50 mb-2">
              Email
            </p>
            <p className="font-display text-xl md:text-2xl text-ink group-hover:text-clinic transition-colors break-all">
              {BUSINESS.email}
            </p>
            <p className="mt-auto pt-4 text-sm text-ink/60">
              Risposta entro 24-48 ore lavorative
            </p>
          </a>
        </Reveal>
        <Reveal delay={0.08} className="bg-paper">
          <a
            href={BUSINESS.mapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-maps-link"
            className="group flex h-full flex-col p-8 md:p-10 transition-colors hover:bg-clinic-tint/60"
          >
            <MapPin size={22} className="text-clinic mb-5" />
            <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-ink/50 mb-2">
              Sede di Roma
            </p>
            <p className="font-display text-xl md:text-2xl text-ink group-hover:text-clinic transition-colors">
              {BUSINESS.streetAddress}
            </p>
            <p className="mt-auto pt-4 text-sm text-ink/60">
              {BUSINESS.postalCode} {BUSINESS.city} — Apri in Google Maps
            </p>
          </a>
        </Reveal>
      </div>

      <Reveal delay={0.2}>
        <div className="mt-12 bg-ink p-10 md:p-14 text-center">
          <p className="font-display text-3xl md:text-5xl text-paper mb-6">
            Metti in regola la tua azienda.
          </p>
          <a
            href={`mailto:${BUSINESS.email}?subject=Richiesta%20preventivo%20sorveglianza%20sanitaria`}
            data-testid="contact-cta-email"
            className="inline-flex items-center gap-2 rounded-full bg-clinic px-8 py-4 font-mono text-[11px] tracking-[0.15em] uppercase text-white transition-transform hover:-translate-y-0.5"
          >
            <Mail size={14} /> Scrivici una email
          </a>
        </div>
      </Reveal>

      <Reveal delay={0.25}>
        <div className="mt-12" data-testid="contact-map">
          <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-clinic mb-4">
            Dove siamo — {BUSINESS.streetAddress}, {BUSINESS.city}
          </p>
          <iframe
            data-testid="contact-map-iframe"
            title="Mappa Google della sede BPMedLav — Viale di Villa Pamphili 99, Roma"
            src="https://maps.google.com/maps?q=Viale%20di%20Villa%20Pamphili%2099%2C%2000152%20Roma&t=&z=16&ie=UTF8&iwloc=&output=embed"
            className="h-80 md:h-96 w-full border border-ink/10"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
        </div>
      </Reveal>
    </div>
  </section>
);
